import * as React from 'react';
import $ from "jquery";
import { Box, Button, Card, CardContent, CircularProgress, colors, Stack, Typography } from '@mui/material';
import { PieChart } from '@mui/x-charts/PieChart';
import Gradient from "javascript-color-gradient";
import { BarChart } from '@mui/x-charts/BarChart';
import { LineChart } from '@mui/x-charts/LineChart';
import Common from '../utilities/common';

export interface IExtraccionesDataComparerChartState {
    data: number;
    dataExtracted: number;
    dataExtractedDistinct: number;
    colors: string[];
}

export default class ExtraccionesDataComparerChart extends React.Component<{}, IExtraccionesDataComparerChartState> {
    public constructor(props: {}) {
        super(props);

        this.state = {
            data: 0,
            dataExtracted: 0,
            dataExtractedDistinct: 0,
            colors: []
        }
    }

    componentDidMount(): void {
        this.Get();
    }

    public render(): React.ReactElement<{}> {
        return (
            <Card>
                <CardContent>
                    <Box display={'flex'} justifyContent={'space-between'}>
                        <Typography variant="h5" component="div">
                            Comparación de datos
                        </Typography>
                    </Box>
                    <PieChart
                            height={350}
                            series={[
                                { 
                                    data: [
                                        {
                                            id: 0,
                                            value: this.state.data,
                                            label: 'Datos',
                                            color: Common.MAN_BORDER_COLOR
                                        },
                                        {
                                            id: 1,
                                            value: this.state.dataExtracted,
                                            label: 'Datos extraídos',
                                            color: Common.WOMAN_BORDER_COLOR
                                        },
                                        {
                                            id: 2,
                                            value: this.state.dataExtractedDistinct,
                                            label: 'Datos extraídos únicos',
                                            color: '#59CD90'
                                        }
                                    ],
                                    highlightScope: { faded: 'global', highlighted: 'item' },
                                    faded: { innerRadius: 30, additionalRadius: -30, color: 'gray' }
                                }
                            ]}
                            margin={{
                                left: 50,
                                right: 50,
                                bottom: 100,
                                top: 50
                            }}
                            slotProps={
                                {
                                    legend: {
                                        direction: 'row',
                                        position: {
                                            vertical: 'bottom',
                                            horizontal: 'middle',
                                        },
                                        itemMarkWidth: 20,
                                        itemMarkHeight: 6,
                                        markGap: 5,
                                        itemGap: 10,
                                        labelStyle: {
                                            fontSize: 11
                                        }
                                    }
                                }
                            }
                        />
                </CardContent>
            </Card>
        )
    }

    private Get() {
        let url = `${Common.END_POINT}/extracciones/datacomparer`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            const data: any[] = [];
            const dataExtracted: any[] = [];
            const dataExtractedDistinct: any[] = [];

            const dataItem: any = {};
            dataItem.label = 'Datos';
            dataItem.value = response[0].total;
            data.push(dataItem);

            const dataItem2: any = {};
            dataItem2.label = 'Datos extraídos';
            dataItem2.value = response[1].total;
            dataExtracted.push(dataItem2);

            const dataItem3: any = {};
            dataItem3.label = 'Datos únicos extraídos';
            dataItem3.value = response[2].total;
            dataExtractedDistinct.push(dataItem3);

            this.setState({
                data: response[0].total,
                dataExtracted: response[1].total,
                dataExtractedDistinct: response[2].total
            })
        })
    }
}